'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'この項目は必須項目です';